/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PrivateBoardIcon/view.blocks to change it.
import React from 'react'
import Tysiav2TaskPrivateBoardIcon from 'DesignSystem/Svgs/Tysiav2TaskPrivateBoardIcon/index'



/** @type {import('Simple/types.js').View} */
export default function PrivateBoardIcon({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Header/Content/No/Title/BoardListIcon/PrivateBoardIcon"
  
}) {
  return (<React.Fragment
>
<Tysiav2TaskPrivateBoardIcon
  viewPath={`${viewPath}/Tysiav2TaskPrivateBoardIcon`}
/>
{children}
</React.Fragment>)
}